import Swiper from "swiper/bundle"

let $ = window.jQuery

document.addEventListener("DOMContentLoaded", () => {
	let swiperParams = {
		slidesPerView: 1,
		spaceBetween: 50,
		autoplay: { delay: 5000 },

		loop: true,
		breakpoints: { 768: { slidesPerView: 3 } },
	}

	let elements = document.querySelectorAll(".swiper")
	for (let element of elements) {
		let slides = element.querySelectorAll(".swiper-wrapper > *")
		slides.forEach((child) => child.classList.add("swiper-slide"))

		let instance = new Swiper(element, swiperParams)
		instance.mount()
	}

	$(document).on(
		"simpl_ajax_submit_success",
		(event, $formEl, data, options) => {
			$formEl.prev(".simpl-ajax-success").remove()
			$formEl.before(
				`<div class="simpl-ajax-success">${data.message}</div>`,
			)

			if (data.hide_form) $formEl.remove()
		},
	)

	$(document).on(
		"simpl_ajax_submit_error",
		(event, $formEl, data, options) => {
			console.log("simpl_ajax_submit_error", event, $formEl, data)
		},
	)

	$(document).on(
		"simpl_ajax_submit_failure",
		(event, $formEl, data, options) => {
			console.log("simpl_ajax_submit_failure", event, $formEl, data)
		},
	)
})
